import Router from './routes/Router';


function App() {
  // console.log = console.error = console.warn = console.info = console.debug = () => {};
  return (
      <Router />
  );
}

export default App;

